import { Container } from "inversify";
import {
    DATES_ADAPTER_TYPE,
    type DatesAdapter,
    DefaultJsonAdapter,
    JSON_ADAPTER_TYPE,
    type JsonAdapter,
    LANG_DATES_ADAPTER_CONST_TYPE,
    LuxonDatesAdapter,
    TIMEZONE_DATES_ADAPTER_CONST_TYPE
} from "inversify-utils-kit";
import "reflect-metadata";

const AppContainer: Container = new Container();

AppContainer.bind<DatesAdapter>(DATES_ADAPTER_TYPE).to(LuxonDatesAdapter);
AppContainer.bind<string>(TIMEZONE_DATES_ADAPTER_CONST_TYPE).toConstantValue(
    Intl.DateTimeFormat().resolvedOptions().timeZone
);
AppContainer.bind<string>(LANG_DATES_ADAPTER_CONST_TYPE).toConstantValue(
    navigator.language
);
AppContainer.bind<JsonAdapter>(JSON_ADAPTER_TYPE).to(DefaultJsonAdapter);

export { AppContainer };
